import { Table, TableProps, Tooltip } from "antd";
import { PhotoDisplayHandler } from "components";
import LinkLanguage from "locales/LinkLanguage";
import { DeleteOutlined, MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { addArticle, removeArticle } from "store/cart/cart.slice";
import { CURRENCY } from "utils/textConstants";
import "./CartTable.scss";
import { showToast } from "utils/helpers/toastHelper";
import { trackEcommerceEvent } from "utils/helpers/analytics";

const CartTable = ({ cartList, view }: any) => {
  const dispatch: any = useDispatch();
  interface DataType {
    key: string;
    slug: string;
    name: string;
    image: string;
    price: number;
    discount: number;
    total_price: number;
    count: number;
    old_price: number;
    product: {
      slug: string;
      name: string;
      image: string;
    };
  }

  const addToCart = (slug: any) => {
    let articleData = getData().filter((i) => i.slug === slug)[0];
    dispatch(
      addArticle({
        price: articleData.price,
        discount: articleData.discount,
        old_price: articleData.old_price,
        slug: articleData.slug,
        name: articleData.name,
        image: articleData.image,
        quantity: 1,
      })
    );

    // showToast(`Proizvod dodat u korpu`, "success");

    trackEcommerceEvent("add_to_cart", {
      currency: "BAM",
      value: articleData.price * 1,
      items: [
        {
          item_id: articleData.slug,
          item_name: articleData.name,
          quantity: 1,
          price: articleData.price,
        },
      ],
    });
  };

  const removeFromCart = (slug: any) => {
    dispatch(
      removeArticle({
        item_slug: slug,
        all_items: false,
      })
    );
    // showToast(`Proizvod uklonjen iz korpe`, "warn");
  };

  const removeAllFromCart = (slug: any) => {
    dispatch(
      removeArticle({
        item_slug: slug,
        all_items: true,
      })
    );
    showToast(`Proizvod uklonjen iz korpe`, "success");
  };

  const getData = () => {
    let data: DataType[] = [];
    cartList.forEach((item: any) => {
      data.push({
        key: item.slug,
        slug: item.slug,
        name: item.name,
        price: item.price,
        total_price: item.total_price,
        image: item.image,
        discount: item.discount,
        count: item.count,
        old_price: item.old_price,
        product: {
          slug: item.slug,
          name: item.name,
          image: item.image,
        },
      });
    });
    return data;
  };

  const columns: TableProps<DataType>["columns"] = [
    {
      title: "Proizvod",
      dataIndex: "product",
      key: "product",
      render: (_, record) => (
        <LinkLanguage
          to={`/article/${record.slug}`}
          className="Cart-Table-Product"
        >
          <div className="Cart-Table-Image">
            <PhotoDisplayHandler
              img_name={record.image}
              calculate={false}
              img_class_name="CartImage"
              img_alt={record.image}
              width=""
              height=""
            />
          </div>
          {record.name}
        </LinkLanguage>
      ),
    },
    {
      title: "Cijena",
      dataIndex: "price",
      key: "price",
      render: (_, record) => (
        <label className="Cart-Table-Label">
          {record.price.toFixed(2)}&nbsp;{CURRENCY}
        </label>
      ),
    },
    {
      title: "Kol.",
      key: "count",
      render: (_, record) => (
        <div className="Cart-Table-Kol">
          {view ? (
            <label className="Cart-Table-Label">{record.count}</label>
          ) : (
            <div className="Cart-Button-Box">
              <button
                onClick={() => removeFromCart(record.slug)}
                className="Cart-Button-Minus"
                disabled={record.count === 0}
                type="button"
              >
                <MinusOutlined className="Cart-Button-Icon" />
              </button>
              <div className="Cart-Button-Box-Input">{record.count}</div>
              <button
                onClick={() => addToCart(record.slug)}
                className="Cart-Button-Plus"
                type="button"
              >
                <PlusOutlined className="Cart-Button-Icon" />
              </button>
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Ukupno",
      dataIndex: "total_price",
      key: "total_price",
      render: (_, record) => (
        <label className="Cart-Table-Label">
          {record.total_price.toFixed(2)}&nbsp;{CURRENCY}
        </label>
      ),
    },
    {
      title: "",
      dataIndex: "delete",
      key: "delete",
      render: (_, record) => {
        return !view ? (
          <div className="Cart-Table-Kol">
            <Tooltip title="Izbaci iz korpe">
              <button
                onClick={() => removeAllFromCart(record.slug)}
                className="button-link"
              >
                <DeleteOutlined />
              </button>
            </Tooltip>
          </div>
        ) : (
          <></>
        );
      },
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={getData()}
      size="small"
      pagination={false}
      className="custom-table"
    />
  );
};
export default CartTable;
